import { Divider, Modal } from '@mui/material'
import React from 'react'
import { useForm } from 'react-hook-form'
import TableMui from 'src/components/TableMui'
import { TableMuiLabel } from 'src/components/TableMui/styles'
import { InvoiceDetail, PendingReceivementConference, ReceivementConference } from '../../../../PendingReceivementsTypes'
import { TableFooter, TableFooterRow } from '../ReceivementConferenceTables.style'
import { resolveTableFooter } from '../ReceivementConferenceTables.utils'
import {
  CancelUpdatesButton, ModalBody, SaveUpdatesButton,
} from './EditQtyPerBoxModal.style'
import lodash from 'lodash'
import { useStore } from 'src/utils/store'
import { actions } from '../../../../PendingReceivementsState'
import { InvoiceItemRow } from './InvoiceItemRow'

interface EditQtyPerBoxModalProps {
  modalIsOpen: boolean
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  receivementToEdit?: PendingReceivementConference
}

export const EditQtyPerBoxModal = ({
  modalIsOpen, setModalIsOpen, receivementToEdit,
}: EditQtyPerBoxModalProps) => {
  const store = useStore()
  const { handleSubmit, register, watch } = useForm()

  const closeEditModal = () => setModalIsOpen(false)

  const updateQtyPerBox = (data) => {
    const receivementConferenceList = store.getState().pendingReceivements.receivementConference
    const receivementConference = receivementConferenceList?.receivementConference!
    const receivementToEditIndex = receivementConference.findIndex((receivement) => receivement.modelId === receivementToEdit?.modelId)

    if (receivementToEditIndex === -1) return

    const updatedReceivement = {
      ...receivementToEdit,
      invoiceDetails: receivementToEdit?.invoiceDetails.map((invoiceDetail, index) => {
        const qtyPerBox: number = data[`qty-per-box-row-${index}`]

        return {
          ...invoiceDetail,
          qtyPerBox,
          expectedQuantity: invoiceDetail.boxQuantity * qtyPerBox,
        }
      }),
    }

    const receivementConferenceClone = lodash.cloneDeep(receivementConference)
    receivementConferenceClone[receivementToEditIndex] = updatedReceivement as PendingReceivementConference

    store.dispatch(actions.setReceivementConference({ ...receivementConferenceList, receivementConference: receivementConferenceClone } as ReceivementConference))
    closeEditModal()
  }

  return (
    <Modal
      open={modalIsOpen}
      onClose={closeEditModal}
      keepMounted
      data-testid='edit-qty-per-box-modal'
    >
      <ModalBody>
        <form onSubmit={handleSubmit(updateQtyPerBox)}>
          <TableMui
            key={receivementToEdit?.modelId}
            columns={[
              {
                id: 'idAr', label: 'AR', width: '25%', testId: 'id-ar-cell',
              },
              {
                id: 'qtyPerBoxInput', label: 'Caixaria', width: '25%', testId: 'qty-per-box-input-cell',
              },
              {
                id: 'boxQuantity', label: 'Qtd. Caixas', width: '25%', testId: 'box-quantity-cell',
              },
              {
                id: 'expectedQuantity', label: 'Qtd. Esperada', width: '25%', testId: 'expected-quantity-cell',
              },
            ]}
            columnsStyle={{ padding: 8 }}
            rows={receivementToEdit?.invoiceDetails.map((invoiceDetail: InvoiceDetail, index: number) => (InvoiceItemRow(invoiceDetail, index, register, watch)))}
            tableLabel={(
              <TableMuiLabel>
                {`${receivementToEdit?.modelId} - ${receivementToEdit?.productDescription}`}
              </TableMuiLabel>
            )}
            thinLine
            tableFooter={(
              <TableFooter>
                <TableFooterRow>{resolveTableFooter(receivementToEdit?.invoiceDetails, watch)}</TableFooterRow>
                <Divider />
                <TableFooterRow>
                  <SaveUpdatesButton type='submit' variant='outlined' data-testid='update-receivement-button'>Salvar Alterações</SaveUpdatesButton>
                  <CancelUpdatesButton variant='outlined' onClick={closeEditModal}>Cancelar Alterações</CancelUpdatesButton>
                </TableFooterRow>
              </TableFooter>
            )}
          />
        </form>
      </ModalBody>
    </Modal>
  )
}
